import angular from 'angular';
import googleAddressAutocompleteDirective from './google-address-autocomplete.component';
import tcGoogleAddressComponent from './tc-google-address.component';
import editableAddressDirective from './editable-address.directive';

let googleAddressAutocompleteModule = angular.module('tcGoogleAddressAutocomplete', [])
  .directive('googleAddressAutocomplete', googleAddressAutocompleteDirective)
  .directive('editableAddress', editableAddressDirective)
  .component('tcGoogleAddress', tcGoogleAddressComponent);

export default googleAddressAutocompleteModule;




// WEBPACK FOOTER //
// ./client/common/directives/google-address-autocomplete/google-address-autocomplete.js